<template>
  <aside class="sensor-body">
    <div class="site-box">
      {{ siteName || '-' }}
    </div>

    <div v-if="!parts || !parts.length" class="empty-message">
      표시할 센서가 없습니다.
    </div>

    <div
      v-for="group in parts"
      :key="group.groupId"
      class="part-box"
    >
      <div class="part-title" @click="onTogglePart(group.groupId)">
        <span class="part-toggle">
          {{ group.expanded ? '▼' : '▶' }}
        </span>
        <span class="part-name">{{ group.groupName }}</span>
      </div>

      <div v-if="group.expanded" class="subgroup-wrap">
        <div
          v-for="subGroup in group.subGroups"
          :key="subGroup.subGroupId"
          class="subgroup-box"
        >
          <div class="subgroup-title">
            {{ subGroup.subGroupName }}
          </div>

          <div class="sensor-list">
            <label
              v-for="item in subGroup.sensors"
              :key="item.itemKey"
              class="sensor-item"
            >
              <input
                type="checkbox"
                :checked="item.checked"
                @change="onToggleSensor(group.groupId, subGroup.subGroupId, item)"
              />

              <span class="sensor-name">
                <span
                  v-if="item.itemType === 'GROUP'"
                  class="sensor-type-badge multi"
                >
                  다단
                </span>

                <span
                  v-else
                  class="sensor-type-badge single"
                >
                  센서
                </span>

                {{ item.sensorName || item.displayName || '-' }}
              </span>
            </label>

            <div v-if="!subGroup.sensors || !subGroup.sensors.length" class="subgroup-empty">
              등록된 항목이 없습니다.
            </div>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'SensorListComponent',

  props: {
    parts: {
      type: Array,
      required: true
    },
    siteName: {
      type: String,
      default: ''
    }
  },

  emits: ['toggle-part', 'toggle-sensor'],

  methods: {
    onTogglePart(groupId) {
      this.$emit('toggle-part', groupId)
    },

    onToggleSensor(groupId, subGroupId, item) {
      this.$emit('toggle-sensor', {
        groupId,
        subGroupId,

        // 기존 단일 센서
        sensorId: item.itemType === 'SENSOR' ? item.sensorId : null,

        // 신규 다단센서 그룹
        sensorGroupId: item.itemType === 'GROUP' ? item.sensorGroupId : null,

        itemKey: item.itemKey,
        itemType: item.itemType
      })
    }
  }
}
</script>

<style scoped>
.sensor-body {
  width: 220px;
  min-width: 220px;
  max-width: 220px;
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: var(--color-white);
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  padding: 10px 8px;
  box-sizing: border-box;
  color: var(--color-text-main);
}

.part-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 12px;
}

.part-title {
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.part-toggle {
  width: 14px;
  display: inline-block;
  text-align: center;
  flex-shrink: 0;
}

.part-name {
  min-width: 0;
  word-break: keep-all;
}

.subgroup-wrap {
  margin-top: 10px;
}

.subgroup-box {
  border-top: 1px dashed #e2e6ec;
  padding-top: 10px;
  margin-top: 10px;
}

.subgroup-box:first-child {
  border-top: none;
  padding-top: 6px;
  margin-top: 6px;
}

.subgroup-title {
  font-size: 12px;
  font-weight: 700;
  color: #4f5b6b;
  margin-bottom: 6px;
  padding-left: 2px;
}

.sensor-list {
  padding-left: 14px;
}

.sensor-item {
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0;
  cursor: pointer;
}

.sensor-name {
  min-width: 0;
  word-break: break-word;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.sensor-type-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 17px;
  padding: 0 5px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
}

.sensor-type-badge.single {
  background: #eef4ff;
  color: #2563eb;
}

.sensor-type-badge.multi {
  background: #f3e8ff;
  color: #7c3aed;
}

.site-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.35;
  background: #fff;
  word-break: keep-all;
}

.empty-message,
.subgroup-empty {
  padding: 12px;
  color: var(--color-text-sub);
  font-size: 12px;
}

@media (max-width: 1100px) {
  .sensor-body {
    width: 100%;
    min-width: 0;
    max-width: none;
    height: auto;
    max-height: 320px;
  }
}

@media (max-width: 900px) {
  .sensor-body {
    padding: 8px;
  }

  .part-box {
    margin-bottom: 10px;
  }

  .site-box {
    font-size: 13px;
  }
}
</style>